module.exports = __webpack_public_path__ + "static/img/img3.c6520379.png";